import React,{useEffect,useState} from 'react';
import {TableDatePicker} from '../function_lib/common_lib';
export function Comp_Edit_Marks(props){
    const [stMarkIds,setMarkIds]=useState("");
  useEffect(()=>{
    let strMarkIds="";
    //alert(JSON.stringify(props.editMarks));
    if(typeof props.editMarks.ls_marks_obt!=="undefined"){
        
        for(let i=0;i<props.editMarks.ls_marks_obt.length;i++){
            if(strMarkIds!==""){
                strMarkIds+=",";
            }
            strMarkIds+=props.editMarks.ls_marks_obt[i]["id"];
        }
    }
    setMarkIds(strMarkIds);
    
  },[props.editMarks])
  //alert(JSON.stringify(props.paymentBreakdown));
    return(<div className="modal fade bd-example-modal-xl"  id="divEditMarks" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl111" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Enter Marks</h5>
          <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        {typeof props.editMarks.ls_marks_obt!=="undefined"?
        <form id="frmEditMarks" name="frmEditMarks">
        <input type="hidden" name="res_func" id="res_func" value="oldDues_okSucc" />
                <input type="hidden" name="curl_type" id="curl_type" value="editResult" />
                <input type="hidden" name="m_type" id="m_type" value="editResult" />
                <input type="hidden" name="pod_stu_admis_id" id="pod_stu_admis_id" value={props.studentId}/>
                <input type="hidden" name="pod_acc_inf_id" id="pod_acc_inf_id" value={props.app_user_id}/>
                <input type='hidden' name="marks_obt_ids" id="marks_obt_ids" value={btoa(stMarkIds)}/>
                <input type='hidden' name="result_id" id="result_id" value={typeof props.editMarks.stu_result!=="undefined"?btoa(props.editMarks.stu_result[0]["id"]):'0'}/>
                
        <div className="modal-body">
        <div className="row">
          <div className='col-md-6'>
          <div className="form-group form-group-sm row">
                                            <label for="exampleInputEmail1">Roll Number.</label>
                                            <div className="input-group input-group-sm">
                                            <input className="form-control required11" type="number" id="edit_roll_number" name="edit_roll_number"/>
                                            </div>
                                        </div>

          </div>
            <div className="col-md-12">
                <table class="table table-bordered table-sm">
                    <tr>
                    <td>Subject</td>
                    <td>Outstanding Marks</td>
                    <td>Marks Obtain</td>
                    <td>Practical</td>
                      </tr>
                  {props.editMarks?.ls_marks_obt.map((item,index)=>{
                    return <tr>
                        <td>{item["subject_nm"]}
                           
                            <input type="hidden" name={"popmarks_hid_outsmarks-"+item["id"]} id={"popmarks_hid_outsmarks-"+item["id"]}
                            value={item["total_marks"]}
                            />
                            <input type='hidden' name={"popmarks_hid_academic_part-"+item["id"]} id={"popmarks_hid_academic_part-"+item["id"]} 
                            value={item["academic_part"]}/>
                        </td>
                        <td>{item["academic_part"]==="Academic"?item["total_marks"]:''}</td>
                        <td>
                            {item["academic_part"]==="Academic"?<>
                            {item["part_one_total"].toString()!=="0"?
                            <input class="form-control required" type="number" defaultValue={item["part_one_obtain"]} name={"popmarks_obtain-"+item["id"]} id={"popmarks_obtain-"+item["id"]} />:
                            <input class="form-control required" type="number" defaultValue={item["obtain_marks"]} name={"popmarks_obtain-"+item["id"]} id={"popmarks_obtain-"+item["id"]} />}
                            
                            </>:
                            <select id={"popmarks_obtain-"+item["id"]} name={"popmarks_obtain-"+item["id"]} class="form-control required">
                                <option value={"0"}>-Select-</option>
                                <option selected={item["grade_applied"]==="A"} value={"A"}>A</option>
                                <option selected={item["grade_applied"]==="B"} value={"B"}>B</option>
                                <option selected={item["grade_applied"]==="C"} value={"C"}>C</option>
                                <option selected={item["grade_applied"]==="NA"} value={"NA"}>NA(Not Applicable)</option>
                            </select>
                            }
                            
                            
                            </td>
                            {item["part_two_total"].toString()!=="0"?<td>
                            <input class="form-control required" type="number" defaultValue={item["part_two_obtain"]} name={"popmarks_obtain_two-"+item["id"]} id={"popmarks_obtain_two-"+item["id"]} />
                            </td>:<td></td>}
                    </tr>
                  })}
                
                </table>

            </div>
                  {/* <!-- left column --> */}
                  <div className="col-md-12">
                      <div className="card card-danger">
                             
                              <div className="card-body">
                                  <div className="row">
                                  <div className="col-md-12">
                                    {/* other results input main */}
                                    {typeof props.editMarks.stu_result!=="undefined"?
                                    <table class="table table-bordered table-sm">
                                      <tr>
                                        <td>Pass/Fail</td>
                                        <td><select  id="pass_fail" name="pass_fail" className='form-control required'>
                                          <option value={"0"}>-select-</option>
                                          <option selected={props.editMarks.stu_result[0]["result_pass"]==="Pass"} value={"Pass"}>Pass</option>
                                          <option selected={props.editMarks.stu_result[0]["result_pass"]==="Fail"} value={"Fail"}>Fail</option>
                                          <option selected={props.editMarks.stu_result[0]["result_pass"]==="Passed by Grace and Promoted to Next Class"} value={"Passed by Grace and Promoted to Next Class"}>Passed by Grace and Promoted to Next Class</option>
                                          <option selected={props.editMarks.stu_result[0]["result_pass"]==="Passed and Promoted to Next Class"} value={"Passed and Promoted to Next Class"}>Passed and Promoted to Next Class</option>
                                          
                                          </select></td>
                                      </tr>
                                      <tr>
                                        <td>Remark</td>
                                        <td><select id="remark" name="remark" className='form-control required'>
                                          <option value={"0"}>-select-</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Excellent"} value={"Excellent"}>Excellent</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Good"} value={"Good"}>Good</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Outstanding"} value={"Outstanding"}>Outstanding</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Brilliant"} value={"Brilliant"}>Brilliant</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Marvellous"} value={"Marvellous"}>Marvellous</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Bravo!"} value={"Bravo!"}>Bravo!</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Very Good"} value={"Very Good"}>Very Good</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Keep It Up!"} value={"Keep It Up!"}>Keep It Up!</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Good Going"} value={"Good Going"}>Good Going</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Good One"} value={"Good One"}>Good One</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Well Done"} value={"Well Done"}>Well Done</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Nice Work"} value={"Nice Work"} >Nice Work</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Very Nice"} value={"Very Nice"} >Very Nice</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Be Regular"} value={"Be Regular"}>Be Regular</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Be Punctual"} value={"Be Punctual"}>Be Punctual</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Be Attentive"} value={"Be Attentive"}>Be Attentive</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Average"} value={"Average"}>Average</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Good Improvement"} value={"Good Improvement"}>Good Improvement</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Satisfactory"} value={"Satisfactory"}>Satisfactory</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Work Hard"} value={"Work Hard"}>Work Hard</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Do Better Next Time"} value={"Do Better Next Time"}>Do Better Next Time</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Do Much Better"} value={"Do Much Better"}>Do Much Better</option>
                                          <option selected={props.editMarks.stu_result[0]["remarks"]==="Need To Improve"} value={"Need To Improve"}>Need To Improve</option>
                                          </select></td>
                                      </tr>
                                      <tr>
                                        <td>Rank</td>
                                        <td><input class="form-control required" type='text' defaultValue={props.editMarks.stu_result[0]["rank"]} id="stu_rank" name="stu_rank" /></td>
                                      </tr>
                                      <tr>
                                        <td>Attendance Days(total)</td>
                                        <td><input class="form-control required" type='number' defaultValue={props.editMarks.stu_result[0]["attend_total"]} id="attend_total" name="attend_total" /></td>
                                      </tr>
                                      <tr>
                                        <td>Attendance Days(Present)</td>
                                        <td><input class="form-control required" type='number' defaultValue={props.editMarks.stu_result[0]["attend_present"]} id="attend_present" name="attend_present" /></td>
                                      </tr>

                                    </table>:''}
                                    {/* end of other input main */}
                                    </div>
                                  </div>
                                
                                  <div className="col-md-6 respSSL"></div>
                                  <div id="testing2dd2222"></div>
                              </div>
                          
                      </div>
                  </div>
              </div>
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" onClick={()=>props.clkEditMarks("frmEditMarks")} className="btn _btnSetColor121213 btn-primary">Submit</button>
        </div>
        </form>
        :''}
      </div>
      </div>
      </div>)
}
export default Comp_Edit_Marks;